/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CargCsclPrgsInfoDtlQryVo } from './CargCsclPrgsInfoDtlQryVo';
import {
    CargCsclPrgsInfoDtlQryVoFromJSON,
    CargCsclPrgsInfoDtlQryVoFromJSONTyped,
    CargCsclPrgsInfoDtlQryVoToJSON,
    CargCsclPrgsInfoDtlQryVoToJSONTyped,
} from './CargCsclPrgsInfoDtlQryVo';
import type { CargCsclPrgsInfoQryVo } from './CargCsclPrgsInfoQryVo';
import {
    CargCsclPrgsInfoQryVoFromJSON,
    CargCsclPrgsInfoQryVoFromJSONTyped,
    CargCsclPrgsInfoQryVoToJSON,
    CargCsclPrgsInfoQryVoToJSONTyped,
} from './CargCsclPrgsInfoQryVo';

/**
 * 
 * @export
 * @interface CargCsclPrgsInfoQryRtnVo
 */
export interface CargCsclPrgsInfoQryRtnVo {
    /**
     * 
     * @type {string}
     * @memberof CargCsclPrgsInfoQryRtnVo
     */
    ntceInfo?: string;
    /**
     * 
     * @type {CargCsclPrgsInfoQryVo}
     * @memberof CargCsclPrgsInfoQryRtnVo
     */
    cargCsclPrgsInfoQryVo?: CargCsclPrgsInfoQryVo;
    /**
     * 
     * @type {number}
     * @memberof CargCsclPrgsInfoQryRtnVo
     */
    tCnt?: number;
    /**
     * 
     * @type {Array<CargCsclPrgsInfoDtlQryVo>}
     * @memberof CargCsclPrgsInfoQryRtnVo
     */
    cargCsclPrgsInfoDtlQryVoList?: Array<CargCsclPrgsInfoDtlQryVo>;
}

/**
 * Check if a given object implements the CargCsclPrgsInfoQryRtnVo interface.
 */
export function instanceOfCargCsclPrgsInfoQryRtnVo(value: object): value is CargCsclPrgsInfoQryRtnVo {
    return true;
}

export function CargCsclPrgsInfoQryRtnVoFromJSON(json: any): CargCsclPrgsInfoQryRtnVo {
    return CargCsclPrgsInfoQryRtnVoFromJSONTyped(json, false);
}

export function CargCsclPrgsInfoQryRtnVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CargCsclPrgsInfoQryRtnVo {
    if (json == null) {
        return json;
    }
    return {
        
        'ntceInfo': json['ntceInfo'] == null ? undefined : json['ntceInfo'],
        'cargCsclPrgsInfoQryVo': json['cargCsclPrgsInfoQryVo'] == null ? undefined : CargCsclPrgsInfoQryVoFromJSON(json['cargCsclPrgsInfoQryVo']),
        'tCnt': json['tCnt'] == null ? undefined : json['tCnt'],
        'cargCsclPrgsInfoDtlQryVoList': json['cargCsclPrgsInfoDtlQryVoList'] == null ? undefined : ((json['cargCsclPrgsInfoDtlQryVoList'] as Array<any>).map(CargCsclPrgsInfoDtlQryVoFromJSON)),
    };
}

export function CargCsclPrgsInfoQryRtnVoToJSON(json: any): CargCsclPrgsInfoQryRtnVo {
    return CargCsclPrgsInfoQryRtnVoToJSONTyped(json, false);
}

export function CargCsclPrgsInfoQryRtnVoToJSONTyped(value?: CargCsclPrgsInfoQryRtnVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'ntceInfo': value['ntceInfo'],
        'cargCsclPrgsInfoQryVo': CargCsclPrgsInfoQryVoToJSON(value['cargCsclPrgsInfoQryVo']),
        'tCnt': value['tCnt'],
        'cargCsclPrgsInfoDtlQryVoList': value['cargCsclPrgsInfoDtlQryVoList'] == null ? undefined : ((value['cargCsclPrgsInfoDtlQryVoList'] as Array<any>).map(CargCsclPrgsInfoDtlQryVoToJSON)),
    };
}

